/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "@/Providers/Auth";
import { Button } from "@/shadcnComponents/ui/button";
import { Checkbox } from "@/shadcnComponents/ui/checkbox";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shadcnComponents/ui/dialog";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ExtPreviewData } from "./ExtPreviewData";
import { ArrowRight, LoaderIcon } from "lucide-react";
import { useToast } from "../../../shadcnComponents/ui/use-toast";
import { useCookies } from "react-cookie";
import { cn } from "../../../lib/utils";
import { Progress } from "../../../shadcnComponents/ui/progress";

const host = import.meta.env.VITE_BACKEND_SERVER_URL;
const EXTENSION_ID = import.meta.env.VITE_EXTENSION_ID;
const EXTENSION_REQUIRED_VERSION = import.meta.env
  .VITE_EXTENSION_REQUIRED_VERSION;

export const SyncLinkedinWithExt = ({
  onSetManually,
  resync,
  redirectUrl,
}: {
  onSetManually?: () => void;
  resync?: boolean;
  redirectUrl?: string;
}) => {
  const params = new URLSearchParams(window.location.search);
  const authstate = useAuth();
  // const navigate = useNavigate();
  const [openExtInstall, setOpenExtInstall] = useState(false);
  const [device, setDevice] = useState("desktop");
  const { toast } = useToast();

  useEffect(() => {
    if (window.innerWidth < 768) {
      setDevice("mobile");
    }
  }, []);

  useEffect(() => {
    if (params.get("source") === "extension") {
      setOpenExtInstall(true);
    }
  }, []);

  return (
    <>
      {openExtInstall && (
        <ExtensionCheckDialog
          open={openExtInstall}
          onOpenChange={setOpenExtInstall}
          content={
            <InstallExtensionDialogContainer
              reSync={resync}
              redirectUrl={redirectUrl}
              closeCurrentWindow={false}
              open={openExtInstall}
            />
          }
        />
      )}
      <div className="w-full md:w-[80%] flex justify-end p-[10px] ">
        {onSetManually && (
          <div className="md:w-[80%] hidden md:flex flex-col md:justify-end md:items-end">
            <div
              onClick={onSetManually}
              className="text-[#DC2627] cursor-pointer text-center font-[Inter] text-[14px] not-italic font-medium leading-[normal] hover:underline flex justify-center items-center"
            >
              Set up manually
              <ArrowRight size={16} className="ml-1" />
            </div>
            <span className="text-[#DC2627] text-center font-[Inter] text-[14px] not-italic font-medium leading-[normal]">
              (Takes about 12-15 minutes)
            </span>
          </div>
        )}
      </div>
      <div className="flex flex-col-reverse md:flex-row justify-around md:w-[80%] w-full px-[20px] items-center  mt-10 md:mt-0  font-inter ">
        <div className="flex w-full flex-col items-center justify-center ">
          <div className="flex flex-col gap-[8px]  scale-[0.8]  rounded-lg overflow-hidden ">
            <iframe
              className="rounded-lg bg-transaprent "
              title="Profile Component"
              src={`/t/${authstate?.loggedUser?.slug}`}
              width="360"
              height="580"
              frameBorder="0"
              onLoad={(e: any) => {
                const iframeDocument = e.target.contentDocument;
                if (iframeDocument) {
                  const iframeStyles = iframeDocument.createElement("style");
                  iframeStyles.textContent = `
                        body {
                          overflow: hidden !important;
                          scrollbarWidth: none;
                          border: none;
                          background:transparent
                        }
                      `;
                  iframeDocument.body.appendChild(iframeStyles);
                }
              }}
            />
            <span className="text-[#A6A6A6] font-inter text-center text-sm not-italic font-normal leading-5 tracking-[0.12px]">
              Continue creating...
            </span>
          </div>
        </div>
        <div className="flex w-full h-full flex-col md:flex-col-reverse gap-[30px] items-center  justify-center">
          <div className="inline-flex md:w-[80%] flex-col justify-center items-start gap-[18px] shrink-0 px-[17px] py-[17px] border rounded-lg border-solid border-[#292F35]">
            <span className="text-slate-200 text-base not-italic font-semibold leading-6text-slate-200 leading-6">
              Setup your Collab Profile
            </span>
            <span className="w-full flex flex-wrap  text-neutral-400 text-xs md:text-sm not-italic font-normal leading-[normal] ">
              Create your collab profile (media kit) using which brands discover
              you and assess your fit for their campaigns. It can be done
              manually or automatically. Most creators choose automatic sync
              because it’s quicker, more accurate & gives you a deep analysis of
              your profile. Plus, it keeps your data up-to-date for brands,
              without having to share screenshots & reports!
            </span>
            <span className=" text-neutral-400 text-xs md:text-sm not-italic font-normal leading-[normal] ">
              Wanna know how it works?{" "}
              <Dialog>
                <DialogTrigger>
                  <span className="underline cursor-pointer ">Click here</span>
                </DialogTrigger>
                <DialogContent className="bg-[#1B1F23] rounded-md border-none max-w-[340px] md:max-w-[600px] ">
                  <DialogHeader className="gap-[20px] text-start">
                    <DialogTitle className="text-[color:var(--Shade-White,#FFF)] text-base not-italic font-semibold leading-6">
                      Why Auto-Sync & How it Works?
                    </DialogTitle>
                    <DialogDescription className="text-neutral-400 flex flex-col gap-[10px] text-xs md:text-sm not-italic font-normal leading-[normal]">
                      <p>
                        Creators like you told us, that sharing details every
                        time a brand needed details for a collaboration, was
                        tedious and repetitive. So we created a Media Kit for
                        you, which will show a brand everything they need to
                        know. To save you even more time and effort, this Media
                        Kit can automatically sync with your LinkedIn profile to
                        keep itself updated.With just a 1-click sync, you’ll be
                        able to:
                      </p>
                      <ol className="list-disc flex flex-col gap-[10px] ml-12 ">
                        <li>Analyse your LinkedIn posts’ performance</li>
                        <li>
                          Check which sentiments in your posts resonate best
                          with your audience
                        </li>
                        <li>
                          Access key profile metrics like average engagement,
                          likes, and comments, all in one place
                        </li>
                      </ol>
                      <p>
                        Soon, we'll even recommend content topics based on what
                        your audience likes.
                      </p>
                      <p>
                        Simply install the extension, sync and use the insights
                        visible on your dashboard to target your content better.
                      </p>
                    </DialogDescription>
                  </DialogHeader>
                </DialogContent>
              </Dialog>
            </span>
            <div
              onClick={() => {
                if (device === "mobile") {
                  toast({
                    title: "Please switch to a desktop to sync",
                    variant: "destructive",
                  });
                }
              }}
            >
              <Button
                className="bg-[#DC2627] "
                onClick={() => setOpenExtInstall(true)}
                disabled={device === "mobile"}
                variant="destructive"
              >
                Auto-Sync My Profile
              </Button>
            </div>
          </div>
          {onSetManually && (
            <div className="md:w-[80%] md:hidden flex flex-col md:justify-end md:items-end">
              <div
                onClick={onSetManually}
                className="text-[#DC2627] cursor-pointer text-center font-[Inter] text-[14px] not-italic font-medium leading-[normal] hover:underline flex justify-center items-center"
              >
                Set up manually
                <ArrowRight size={16} className="ml-1" />
              </div>
              <span className="text-[#DC2627] text-center font-[Inter] text-[14px] not-italic font-medium leading-[normal]">
                (Takes about 12-15 minutes)
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

interface ExtensionCheckDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trigger?: React.ReactNode;
  className?: string;
  content: React.ReactNode;
}

export const ExtensionCheckDialog: React.FC<ExtensionCheckDialogProps> = ({
  trigger,
  open,
  onOpenChange,
  className,
  content,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {trigger && <DialogTrigger>{trigger}</DialogTrigger>}
      <DialogContent
        className={cn(
          "w-[400px] bg-gray-800 border-[#1c1c1c] border p-0 rounded-lg",
          className
        )}
      >
        {content}
      </DialogContent>
    </Dialog>
  );
};

interface InstallExtensionDialogContainerProps {
  reSync?: boolean;
  redirectUrl?: string;
  extTargetUrl?: string;
  closeCurrentWindow?: boolean;
  onOpenChange?: (open: boolean) => void;
  open: boolean;
}

export const InstallExtensionDialogContainer: React.FC<
  InstallExtensionDialogContainerProps
> = ({
  reSync = false,
  redirectUrl,
  extTargetUrl,
  closeCurrentWindow = false,
  open,
}) => {
  const navigate = useNavigate();
  const authstate = useAuth();
  const [, setCookies] = useCookies();
  const [checked, setChecked] = useState(false);
  const [extensionMetaData, setExtensionMetaData] = useState({
    installedVersion: null,
    hasInstalled: false,
    updateRequired: false,
    extensionId: EXTENSION_ID,
    requiredVersion: EXTENSION_REQUIRED_VERSION,
  });
  const [loading, setLoading] = useState(true);
  const [extensionUsage, setExtensionUsage] = useState({
    usedCount: null,
    dailyLimit: null,
    lastSyncTime: null,
    isLimitExceeded: false,
    nextAvailableTime: null,
    remainingHours: null,
    percentage: 0,
  });

  useEffect(() => {
    setChecked(authstate?.loggedUser?.extensionConsent);

    const lastSyncTime = new Date(
      authstate?.loggedUser?.extensionUsage?.lastSyncTime
    );
    const nextAvailableTime = new Date(
      lastSyncTime.getTime() + 24 * 60 * 60 * 1000
    );
    const currentTime = new Date();
    const remainingTimeInMs =
      nextAvailableTime.getTime() - currentTime.getTime();
    const remainingHours = Math.max(
      Math.floor(remainingTimeInMs / (1000 * 60 * 60)),
      0
    );

    setExtensionUsage({
      usedCount: authstate?.loggedUser?.extensionUsage?.usedCount,
      dailyLimit: authstate?.loggedUser?.extensionUsage?.dailyLimit,
      lastSyncTime: authstate?.loggedUser?.extensionUsage?.lastSyncTime,
      nextAvailableTime,
      remainingHours,
      percentage:
        (authstate?.loggedUser?.extensionUsage?.usedCount * 100) /
        authstate?.loggedUser?.extensionUsage?.dailyLimit,
      isLimitExceeded:
        authstate?.loggedUser?.extensionUsage?.usedCount >=
          authstate?.loggedUser?.extensionUsage?.dailyLimit &&
        authstate?.loggedUser?.is_verified &&
        !!authstate?.loggedUser?.mobile,
    });
  }, [authstate?.loggedUser]);

  // console.log(extensionUsage);

  useEffect(() => {
    if (chrome && chrome.runtime && chrome.runtime.sendMessage) {
      const jwtToken = localStorage.getItem("jwtToken");
      const UserType = localStorage.getItem("UserType");
      chrome.runtime.sendMessage(
        extensionMetaData?.extensionId,
        { message: "version", data: { jwtToken, UserType } },
        (reply) => {
          if (chrome.runtime.lastError) {
            console.error("Error: No response from the extension");
            setExtensionMetaData({ ...extensionMetaData, hasInstalled: false });
          } else if (reply && reply.version) {
            if (reply.version >= extensionMetaData?.requiredVersion) {
              setExtensionMetaData({
                ...extensionMetaData,
                hasInstalled: true,
                installedVersion: reply.version,
              });
            }
            if (reply.version < extensionMetaData?.requiredVersion) {
              setExtensionMetaData({
                ...extensionMetaData,
                hasInstalled: true,
                installedVersion: reply.version,
                updateRequired: true,
              });
            }
          } else {
            setExtensionMetaData({ ...extensionMetaData, hasInstalled: false });
          }
        }
      );
    } else {
      console.error("Chrome runtime messaging API is not available.");
    }
  }, []);

  const handleContinue = async () => {
    try {
      // setCookies("extscurl", window.location.href, { path: "/" });

      await authstate?.getUserData().then(async () => {
        if (extensionUsage?.isLimitExceeded) {
          return;
        }
      });

      if (!authstate?.loggedUser?.extensionConsent) {
        const res = await axios.post(
          `${host}/influencer/extension/consent`,
          { extensionConsent: checked },
          {
            headers: {
              jwtToken: localStorage.getItem("jwtToken"),
            },
          }
        );
        if (res?.data?.success) {
          console.log("Extension consent updated successfully");
        }
      }

      const generateLinkedInUrl = ({ params }: { params?: object }) => {
        const code = Math.random().toString(36).substring(7);

        const url = "https://www.linkedin.com/in/me/";
        const baseParams = {
          ref: "anchors",
          code: code,
          page: "profile",
        };
        const queryparams = new URLSearchParams({
          ...baseParams,
          ...params,
        });

        return `${url}?${queryparams.toString()}`;
      };

      const extparams = {
        redirect_url:
          redirectUrl || `${window.location.origin}/influencer/dashboard`,
        "preview-data": "true",
      };

      const getUpdatedData = async () => {
        const res = await axios.get(`${host}/ext/linkedin/me`, {
          headers: { jwtToken: localStorage.getItem("jwtToken") },
        });

        if (res?.data?.success) {
          // console.log(res?.data);
          if (
            res?.data?.data?.profile?.name &&
            res?.data?.data?.posts?.length
          ) {
            navigate("/influencer/dashboard/?preview-data=true");
          } else {
            window.open(
              extTargetUrl || generateLinkedInUrl({ params: extparams }),
              "_blank"
            );
          }
        } else {
          window.open(
            extTargetUrl || generateLinkedInUrl({ params: extparams }),
            "_blank"
          );
        }
      };

      if (extensionUsage?.isLimitExceeded) {
        setExtensionUsage((prev) => {
          return {
            ...prev,
            isLimitExceeded: true,
          };
        });
        setLoading(false);
        return;
      }

      if (reSync) {
        const url = extTargetUrl || generateLinkedInUrl({ params: extparams });
        window.open(url, "_blank");
      } else {
        getUpdatedData();
      }
    } catch (error) {
      console.error("Failed to update extension consent:", error);
    } finally {
      authstate?.setReFetchUserData((prev) => {
        return !prev;
      });
    }
  };

  const handleInstallExtension = async () => {
    setCookies("extscurl", window.location.href, { path: "/" });
    const url = `https://chromewebstore.google.com/detail/linkedin-media-kit-genera/${extensionMetaData?.extensionId}`;
    if (extensionMetaData?.hasInstalled) {
      if (extensionMetaData?.updateRequired) {
        window.open(url, "_blank"); // Update Extension
      } else {
        // Continue
        await handleContinue();
      }
    } else {
      window.open(url, "_blank"); // Install Extension
    }

    if (closeCurrentWindow) {
      // console.log("Closing window");
      setTimeout(() => {
        window.close();
      }, 3000);
    }
  };

  useEffect(() => {
    let isMounted = true;
    async function continueNext() {
      try {
        if (extensionUsage?.isLimitExceeded) {
          return;
        }
        if (
          extensionMetaData?.hasInstalled &&
          !extensionMetaData?.updateRequired &&
          authstate?.loggedUser?.extensionConsent
        ) {
          setLoading(true);
          await new Promise<void>((resolve) => {
            setTimeout(async () => {
              if (isMounted && open) {
                await handleInstallExtension();
              }
              resolve();
            }, 3000);
          });
        }
      } catch (error) {
        console.error("Failed to update extension consent:", error);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    if (open) {
      continueNext();
    }
    return () => {
      isMounted = false; // Set the flag to false when the component unmounts
    };
  }, [
    extensionMetaData?.hasInstalled,
    extensionMetaData?.updateRequired,
    open,
  ]);

  return (
    <>
      {loading ? (
        <div className="p-4 text-white flex gap-2">
          <LoaderIcon className="animate-spin" />
          <span>Loading...</span>
        </div>
      ) : !extensionUsage?.isLimitExceeded ? (
        <div className="text-white">
          <h1 className="text-xl border-b border-[#3a3a3a] px-3 py-2">
            {extensionMetaData?.hasInstalled
              ? extensionMetaData?.updateRequired
                ? "Update Extension"
                : "Extension Installed"
              : "Install Extension"}
            <span className="text-muted-foreground text-xs">
              {extensionMetaData?.hasInstalled
                ? extensionMetaData?.updateRequired
                  ? ` >=(v${extensionMetaData?.requiredVersion})`
                  : ` (v${extensionMetaData?.installedVersion})`
                : ""}
            </span>
          </h1>
          {(!authstate?.loggedUser?.extensionConsent ||
            !extensionMetaData?.hasInstalled) && (
            <div className="p-4 items-center justify-center">
              {/* <h3 className="text-gray-200">Terms & Conditions</h3> */}
              <p className="text-xs text-muted-foreground">
                <b>anchors</b> is your digital space to monetize your content
                and grow together as part of a supportive community of peers.
                With features like Collaboration Feed, Revenue Sharing, & Free
                Tools needed for content creation, you're all set. <br />
                <br />
                To make the most out of <b> anchors</b>, we need your consent to
                sync your LinkedIn posts and profile. Learn more about
                permissions{" "}
                <span
                  className="hover:underline text-[#DC2627] cursor-pointer"
                  onClick={() =>
                    window.open(
                      "https://www.anchors.in/privacy-policy",
                      "_blank"
                    )
                  }
                >
                  here.
                </span>
              </p>
            </div>
          )}
          <div className="p-4 space-y-4">
            {(!authstate?.loggedUser?.extensionConsent ||
              !extensionMetaData?.hasInstalled) && (
              <div className="flex items-center space-x-2">
                <Checkbox
                  id="terms"
                  onCheckedChange={(value) => setChecked(!!value)}
                  checked={checked}
                  className="border-[#fff]"
                />
                <label
                  htmlFor="terms"
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                  I understand and give permission to <b>anchors</b> to sync my
                  LinkedIn posts and profile.
                </label>
              </div>
            )}
            <div className="flex justify-end">
              <Button
                variant="secondary"
                className="w-full"
                onClick={handleInstallExtension}
                disabled={!checked}
              >
                {extensionMetaData?.hasInstalled
                  ? extensionMetaData?.updateRequired
                    ? "Update Extension"
                    : "Continue"
                  : "Install Extension"}
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div className="space-y-4 font-inter p-5 bg-white rounded-lg text-black">
          <DialogHeader>
            <DialogTitle>Sync Limit Reached</DialogTitle>
            <DialogDescription>
              You've hit the maximum sync attempts for today
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 my-4">
            <div className="text-center text-2xl font-bold">
              {extensionUsage?.usedCount >= extensionUsage?.dailyLimit
                ? extensionUsage?.dailyLimit
                : extensionUsage?.usedCount}
              /{extensionUsage?.dailyLimit}
            </div>
            <Progress
              value={
                extensionUsage?.usedCount >= extensionUsage?.dailyLimit
                  ? 100
                  : extensionUsage?.percentage
              }
              className="w-full h-4"
            />
            <div className="text-center text-sm text-gray-600">
              Attempts used in the past 24 hrs
            </div>
          </div>
          <p className="text-center text-amber-600 font-semibold my-4">
            Please try again after the limit resets tomorrow. For any concerns,
            contact the support team.
          </p>
          <DialogFooter>
            <DialogClose className="w-full">
              <Button className="w-full">Got it</Button>
            </DialogClose>
          </DialogFooter>
        </div>
      )}
    </>
  );
};

export const SyncMyLinkedinUsingPlugin = () => {
  // const params = new URLSearchParams(window.location.search);
  const navigate = useNavigate();
  return (
    <>
      <div className="w-full  min-h-screen flex flex-col items-center justify-start bg-[#171717] h-full ">
        <div className="w-full border-b border-[#262626]">
          <div className="mx-auto max-w-[1440px] py-3 px-10">
            <img
              src={
                // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/anchors_Christmas.svg"
                // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/DiwaliLogoBlack.png"
                // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Collab+White+Logo.svg"
                "https://anchors-assets.s3.ap-south-1.amazonaws.com/anchors+logo+with+white+text.png"
              }
              alt=""
              className="w-20 md:w-32 cursor-pointer"
              onClick={() => {
                navigate("/influencer/dashboard");
              }}
            />
          </div>
        </div>
        <ExtPreviewData />
      </div>
    </>
  );
};
